import styled from 'styled-components';

export const GroupImage = styled.img`
  width: 50px;
  height: 50px;
  margin: 10px 10px 0px 0px;
`;
